<script lang="ts">
    import { onMount } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import dayjs from 'dayjs'
    import { EventSourcesRepository } from '../../modules/eventsApi/event-sources/event-sources.repository'
    import { EventSourcesService } from '../../modules/eventsApi/event-sources/event-sources.service'
    import type { User } from '../../modules/usersApi/users/user'
    import type { EventSource } from '../../modules/eventsApi/event-sources/event-source.entity'
    import { faChevronUp, faLongArrowAltUp, faPowerOff } from '@fortawesome/free-solid-svg-icons'
    import { tick } from 'svelte'
    // ##############################################################################################################

    export let personId: string

    const esRep: EventSourcesRepository = new EventSourcesRepository()
    const esS: EventSourcesService = new EventSourcesService(esRep)

    let show = false
    let eventSources: EventSource[] = []
    let users: User[] = []

    let showCom = false
    let format: 'grid' | 'timeline' = 'grid'

    function checkCom(source: string) {
        if (showCom) return true
        if (source === 'whatsapp' || source === 'voip' || source === 'telefone' || source === 'sms' || source === 'email') {
            return false
        }
        return true
    }

    let timeLine: Grid[] = []
    async function loadEntities() {
        try {
            show = true
            users = await window.api.users.companies.getCompanyUsers()
            eventSources = await esS.getAll({ personId })
            for (const es of eventSources) {
                for (const event of es.event) {
                    event.user = users.find((el) => el.userId === event.userId)
                }
            }
            console.log('eventSources', eventSources)
            updateTimeline()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function editEntity(id: string) {}

    function evaluateError(error) {
        window.error(error)
    }

    onMount(async () => {
        await loadEntities()
    })

    async function showComChanged() {
        show = true
        await tick()
        eventSources = eventSources
        updateTimeline()
        show = false
    }

    interface Grid {
        source: string
        externalDate: Date
        content: string
        event_createdAt: Date
        event_event: string
        event_userName: string
        selected: boolean
    }

    function updateTimeline() {
        timeLine = []
        for (const es of eventSources) {
            if (!checkCom(es.source)) continue
            for (const event of es.event) {
                timeLine.push({
                    content: es.content,
                    externalDate: es.externalDate,
                    source: es.source,
                    event_createdAt: event.createdAt,
                    event_event: event.event,
                    event_userName: event.user?.userName || '-',
                    selected: false,
                })
            }
        }
        timeLine.sort((a, b) => {
            return +new Date(b.event_createdAt) - +new Date(a.event_createdAt)
        })
    }

    function getTimelineInterval(current: number) {
        if (current === timeLine.length - 1) return null
        const from = new Date(timeLine[current]?.event_createdAt)
        const to = new Date(timeLine[current + 1]?.event_createdAt)
        const diff = (from.getTime() - to.getTime()) / 1000
        return getFriendlyInterval(diff)
    }

    function getFriendlyInterval(seconds: number) {
        seconds = Number(seconds)
        let d = Math.floor(seconds / (3600 * 24))
        let h = Math.floor((seconds % (3600 * 24)) / 3600)
        let m = Math.floor((seconds % 3600) / 60)
        let s = Math.floor(seconds % 60)

        if (d === 1) return { size: 4, text: '1 dia' }
        if (d > 1) return { size: 4, text: d + ' dias' }
        if (h === 1) return { size: 3, text: '1 hora' }
        if (h > 1) return { size: 3, text: h + ' horas' }
        if (m === 1) return { size: 2, text: '1 minuto' }
        if (m > 1) return { size: 2, text: m + ' minutos' }
        if (s === 1) return { size: 1, text: '1 segundo' }
        return { size: 1, text: s + ' segundos' }
    }

    let gridSelected: string[] = []
    function gridSelectedChanged(id: string) {
        const pos = gridSelected.findIndex((el) => el === id)
        if (pos > -1) {
            gridSelected.splice(pos, 1)
        } else {
            gridSelected.push(id)
        }
        eventSources = eventSources
    }

    function timelineSelectedChanged(position: number) {
        timeLine[position].selected = !timeLine[position].selected
        timeLine = timeLine
    }
</script>

<div class="grid-body p-2">
    <div class="row">
        <div class="col d-flex">
            <div class="form-check form-check-inline">
                <input type="radio" name="eventFormat" bind:group={format} value="grid" id="formatGrid" class="form-check-input" />
                <label for="formatGrid">Lista agrupada</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" name="eventFormat" bind:group={format} value="timeline" id="formatTimeline" class="form-check-input" />
                <label for="formatTimeline">Linha do tempo</label>
            </div>

            <div class="spacer" />
            <div class="form-check form-switch me-2">
                <input class="form-check-input" bind:checked={showCom} on:change={showComChanged} type="checkbox" role="switch" id="showDate" />
                <label class="form-check-label" for="showDate">Exibir eventos de WhatsApp / Telefone / SMS / E-mail</label>
            </div>
        </div>
    </div>

    {#if !show && eventSources}
        {#if format === 'grid'}
            {#each eventSources as es}
                {#if checkCom(es.source)}
                    <div
                        class="grid-format-row"
                        class:timeline_item_selected={gridSelected.some((el) => el === es.eventSourceId)}
                        on:click={() => gridSelectedChanged(es.eventSourceId)}
                    >
                        <div class="row line liner py-1 green bg">
                            <div class="col">
                                <div>
                                    Origem: {es.source} em {dayjs(es.externalDate).format('DD/MM/YYYY HH:mm:ss')}
                                </div>
                                <div>
                                    Conteúdo: {es.source === 'whatsapp' ? '[text]' : es.content?.substring(0, 300)}
                                </div>
                            </div>
                        </div>
                        <div class="row line liner py-1 text-muted">
                            <div class="col-md-2">Data do evento</div>
                            <div class="col text-muted">Evento</div>
                            <div class="col-2 text-muted">Usuário</div>
                        </div>
                        {#each es.event as event}
                            <div class="row line liner py-1">
                                <div class="col-md-2">
                                    {dayjs(event.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                                </div>
                                {#if event.event === 'publico_entrou' || event.event === 'publico_saiu'}
                                    <div class="col">{event.event} (pub: {es.content.split(',')[1]})</div>
                                {:else if event.event.startsWith('automacao_')}
                                    <div class="col nowrap">{event.event} (aut: {es.content.split(',')[0]})</div>
                                {:else}
                                    <div class="col">{event.event}</div>
                                {/if}

                                <div class="col-2 nowrap">{event.user?.userName || '-'}</div>
                            </div>
                        {/each}
                    </div>
                {/if}
            {/each}
        {:else}
            <div class="timeline">
                {#each timeLine as item, index}
                    {@const interval = getTimelineInterval(index)}
                    <div class="timeline_item" class:timeline_item_selected={item.selected} on:click={() => timelineSelectedChanged(index)}>
                        <div class="row text-muted">
                            <div class="col text-muted">Evento</div>
                            <div class="col-2 timeline_date_label">Data do evento</div>
                            <div class="col-2 text-muted">Origem</div>
                            <div class="col-2 timeline_date_label">Data na origem</div>
                            <div class="col-2 text-muted">Usuário</div>
                        </div>
                        <div class="row">
                            {#if item.event_event === 'publico_entrou' || item.event_event === 'publico_saiu'}
                                <div class="col nowrap">{item.event_event} (pub: {item.content.split(',')[1]})</div>
                            {:else if item.event_event.startsWith('automacao_')}
                                <div class="col nowrap">{item.event_event} (aut: {item.content.split(',')[0]})</div>
                            {:else}
                                <div class="col nowrap">{item.event_event}</div>
                            {/if}
                            <div class="col-2 timeline_date">
                                {dayjs(item.event_createdAt).format('DD/MM/YY HH:mm:ss')}
                            </div>
                            <div class="col-2">
                                {item.source}
                            </div>
                            <div class="col-2 timeline_date">
                                {dayjs(item.externalDate).format('DD/MM/YY HH:mm:ss')}
                            </div>

                            <div class="col-2 nowrap">{item.event_userName}</div>
                        </div>
                    </div>
                    {#if interval}
                        <div class="timeline_interval">
                            {#each Array(interval.size) as _}
                                <Fa icon={faChevronUp}></Fa>
                            {/each}
                            <div class="timeline_interval_text">{interval.text}</div>
                            {#each Array(interval.size) as _}
                                <Fa icon={faChevronUp}></Fa>
                            {/each}
                        </div>
                    {/if}
                {/each}
            </div>
        {/if}
    {/if}
</div>

<style>
    .line {
        font-size: 14px;
    }
    .green {
        color: #379e75;
    }
    .bg {
        background: #99999910;
    }
    .grid-body .bg {
        margin-top: 16px;
    }
    .grid-body .bg:first-child {
        margin-top: 0px;
    }

    .timeline {
        padding-top: 8px;
        font-size: 13px;
    }
    .timeline_item {
        background-color: #66666620;
        padding: 8px 4px;
        border-radius: 4px;
        border: 1px solid #66666640;
        cursor: pointer;
    }
    .timeline_interval {
        color: #999;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 11px;
        margin: 8px 0px 6px 0px;
    }
    .timeline_interval_text {
        font-size: 13px;
        margin-bottom: 6px;
    }
    .timeline_date {
        font-size: 13px;
        max-width: 140px;
    }
    .timeline_date_label {
        max-width: 140px;
    }

    .timeline_item_selected {
        border: 1px solid green !important;
    }

    .grid-format-row {
        padding: 0px 4px;
        margin-top: 12px;
        background-color: #66666620;
        overflow: hidden;
        border-radius: 4px;
        border: 1px solid #66666640;
        cursor: pointer;
    }
</style>
